module.exports = __webpack_public_path__ + "img/徐镇镇-c.7d35453c.png";